export const SUPPORT_EMAIL = 'info@keyown.com';
export const KEY_EMAIL_NAME = 'Key';
export const UPDATE_PROFILE_INFO_ERROR_MESSAGE = `We were unable to update your profile info. Please contact ${SUPPORT_EMAIL} for help.`;
